export const sliderItems = [
    {
      id: 1,
      img: "https://www.fashiongonerogue.com/wp-content/uploads/2014/04/iggy-azalea-revolve-clothing-photos-2014-2.jpg",
      title: "A MODEST PROPOSAL",
      desc: "DISCOVER OUR SHOES, ICONIC BAGS, CLOTHING FAVOURITES AND MORE.",
      bg: "f5f5f5"
    },
    {
      id: 2,
      img: "https://i.ibb.co/1G5rGJ1/Excited-young-girl-in-orange-sweater-fooling-around-in-studio-jumping-with-fluttering-hair-isolated.jpg",
      title: "AUTUMN COLLECTION",
      desc: "DISCOVER OUR SHOES, ICONIC BAGS, CLOTHING FAVOURITES AND MORE.",
      bg: "f2ab37",
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/8074534/pexels-photo-8074534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
      title: "SUMMER SALE",
      desc: "DISCOVER OUR SHOES, ICONIC BAGS, CLOTHING FAVOURITES AND MORE.",
      bg: "e5e4e0",
    },
  ];

  export const categories = [
    { 
      id: 1,
      img: "https://images.pexels.com/photos/3682293/pexels-photo-3682293.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
      title: "SHOES",
      cat:"shoes"
    },
    {
      id: 2,
      img: "https://images.pexels.com/photos/7747108/pexels-photo-7747108.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
      title: "BAGS",
      cat:"bags"
    },
    {
      id: 3,
      img: "https://images.pexels.com/photos/5442465/pexels-photo-5442465.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
      title: "JEWELLERRY",
      cat:"jewellery"
    },
  ];